import { Box, Grid } from "@mui/material";
import { Tabs } from "antd";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../components/general/Loader";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import { showWarningSwal } from "../functions/alert";
import { getCompetition } from "../functions/getData";
import {
  uploadMMMCompetitionParticipantAnswers,
  uploadMWCompetitionParticipantAnswers,
  uploadNonSimocCompetitionParticipantAnswers,
} from "../functions/postData";
import { showNotification } from "../functions/snackbar";

export default function UploadTeamCompetitionStudentAnswer() {
  let location = useLocation();

  const controller = useMemo(() => new AbortController(), []);
  const signal = controller.signal;
  const [contestName, setName] = useState("");
  const [competition, setCompetition] = useState([]);
  const [isSimoc, setIsSimoc] = useState("false");
  document.title = "Upload Answer";
  const [round, setRound] = useState();
  const [levelOptions, setLevelOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (location.search.slice(0, 4) === "?id=") {
      getCompetition(
        `/${Number(location.search.slice(4).split("&")[0])}`,
        signal
      ).then((res) => {
        setIsLoading(true);
        const competition = res;
        setRound(competition.rounds[0].id);
        setName(competition.name);
        setIsSimoc(location.search.split("&")[1].split("=")[1]);
        setCompetition(res);
        setIsLoading(false);
      });
    }
    return () => {
      controller.abort();
    };
  }, [controller, signal]);

  useEffect(() => {
    if (competition.rounds) {
      let levelOptionss = [];
      competition.rounds.map((round, index) => {
        round.levels.map((el) => {
          let obj = { id: el.id, option: `round${index + 1} ${el.name}` };
          levelOptionss.push(obj);
        });
      });
      setLevelOptions(levelOptionss);
    }
  }, [competition, setName]);

  const [csvFile, setCSVFile] = useState(null);
  const [mmmFile, setMmmFile] = useState(null);
  const [mvFile, setMvFile] = useState(null);
  const [nonSimocCompetitionFile, setNonSimocCompetitionFile] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const tabStyle = `
    .custom-tabs .ant-tabs-tab {
      flex: 1;
      justify-content: center;
      text-align: center;
      color: var(--color-primary);
      background-color:var(--simcc-grey-150)  !important;
    }

    .custom-tabs .ant-tabs-nav-list {
      display: flex;
      width: 100%;
    }

    .custom-tabs .ant-tabs-tab-active {
      background-color: var(--color-primary) !important;
      border-radius: 12px 12px 0 0;
      font-weight: bold;
    }

    .custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #ffffff !important;
  }
  `;

  const downloadMMMTemplate = () => {
    // Create headers array
    const headers = [
      "Division",
      "Team number",
      "Set",
      "Question 1",
      "Question 2",
      "Question 3",
      "Question 4",
    ];

    // Create CSV content with headers and 5 rows
    const csvContent = [
      headers.join(","),
      ",,1,,,,",
      ",,2,,,,",
      ",,3,,,,",
      ",,4,,,,",
      ",,5,,,,",
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "mmm-template.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadMWTemplate = () => {
    // Create headers array
    const headers = [
      "Index Number",
      "Grade",
      "Division",
      "Team Number",
      "R1G1",
      "R1G2",
      "R1G3",
      "R2G1",
      "R2G2",
      "R2G3",
    ];

    // Create CSV content with headers and 5 empty rows
    const csvContent = [
      headers.join(","),
      ",,,,,,,,,",
      ",,,,,,,,,",
      ",,,,,,,,,",
      ",,,,,,,,,",
      ",,,,,,,,,",
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "mw-template.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadGeneralCompetitionTemplate = () => {
    // TODO: Add the correct headers and content for the general competition template.
    // Create headers array
    const headers = [
      "Division",
      "Team number",
      "Question 1",
      "Question 2",
      "Question 3",
      "Question 4",
    ];

    // Create CSV content with headers and 5 rows
    const csvContent = [
      headers.join(","),
      ",1,,",
      ",2,,",
      ",3,,",
      ",4,,",
      ",5,,",
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "general-competition-template.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Example handler for MMM
  const handleMMMFileUpload = async () => {
    try {
      if (!mmmFile) {
        showWarningSwal("Please select a file first");
        return;
      }

      const response = await uploadMMMCompetitionParticipantAnswers(
        competition?.id,
        mmmFile
      );
      showNotification(
        "success",
        "File uploaded successfully",
        enqueueSnackbar,
        closeSnackbar
      );
      // Clear the file after successful upload
      setMmmFile(null);
    } catch (err) {
      console.error("MMM upload error:", err);
    }
  };

  // Example handler for MW
  const handleMWFileUpload = async () => {
    try {
      if (!mvFile) {
        showWarningSwal("Please select a file first");
        return;
      }

      const response = await uploadMWCompetitionParticipantAnswers(
        competition?.id,
        mvFile
      );
      showNotification(
        "success",
        "File uploaded successfully",
        enqueueSnackbar,
        closeSnackbar
      );
      // Clear the file after successful upload
      setMvFile(null);
    } catch (err) {
      console.error("MW upload error:", err);
    }
  };

  // Example handler for MMM
  const handleNonSimocCompetitionFileUpload = async () => {
    try {
      if (!nonSimocCompetitionFile) {
        showWarningSwal("Please select a file first");
        return;
      }

      // TODO: Uncomment this when the API is ready and use the correct function with correct path.
      const response = await uploadNonSimocCompetitionParticipantAnswers(
        nonSimocCompetitionFile,
        competition?.id
      );
      showNotification(
        "success",
        "File uploaded successfully",
        enqueueSnackbar,
        closeSnackbar
      );
      // Clear the file after successful upload
      setNonSimocCompetitionFile(null);
    } catch (err) {
      console.error("upload error:", err);
    }
  };

  const handleMmmFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (
      selectedFile &&
      [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(selectedFile.type)
    ) {
      setMmmFile(selectedFile);
    } else {
      alert("Only CSV or XLSX files are allowed");
    }
  };

  const handleMvFileChange = (event) => {
    const selectedFile = event.target.files[0];
    console.log("eeeeff");
    console.log(selectedFile);
    if (
      selectedFile &&
      [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(selectedFile.type)
    ) {
      console.log("eeeeff22");
      console.log(selectedFile);
      setMvFile(selectedFile);
    } else {
      alert("Only CSV or XLSX files are allowed");
    }
  };

  const handleNonSimocCompetitionFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (
      selectedFile &&
      [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(selectedFile.type)
    ) {
      setNonSimocCompetitionFile(selectedFile);
    } else {
      alert("Only CSV or XLSX files are allowed");
    }
  };

  if (isLoading) {
    return <Loader height={600} />;
  }

  return (
    <Box style={{ flexGrow: 1 }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ paddingInline: 42, marginTop: 30 }}
      >
        <NunitoText
          value={`${contestName} - Upload Participant's Answers`}
          fontSize={22}
          fontWeight={650}
          
          color='var(--color-text)' align='left' />
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: 30, width: "100%" }}
        ></Grid>
        <style>{tabStyle}</style>
        <Tabs
          className="custom-tabs"
          defaultActiveKey="MMM"
          type="card"
          size="large"
          style={{
            marginBottom: 32,
            width: "100%",
            border: "2px solid var(--color-primary)",
            borderRadius: "8px",
          }}
          items={
            // TODO: modify this to show the tabs based on the correct variable that will differentiate between simoc and others.
            isSimoc === "true"
              ? [
                  {
                    label: "MMM",
                    key: "MMM",
                    children: (
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems={"center"}
                        style={{ padding: 32 }}
                      >
                        <div>
                          <NunitoText
                            value={`File Select:${
                              csvFile ? ` ${csvFile.name}` : ""
                            }`}
                            fontSize={20}
                            fontWeight={600}
                            color="var(--color-primary)"
                            align="left"
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 20,
                            }}
                          >
                            <NunitoText
                              value="Only Upload CSV or XLSX File"
                              fontSize={20}
                              fontWeight={600}
                              color="var(--color-primary)"
                              align="left"
                            />

                            <div>
                              <input
                                type="file"
                                accept=".csv, .xlsx"
                                onChange={handleMmmFileChange}
                              />
                            </div>
                            <ReusableButton
                              text="Upload File"
                              bgColor="var(--color-primary)"
                              fontSize={14}
                              height={44}
                              width={140}
                              iconType="save"
                              onClick={() => handleMMMFileUpload()}
                              disabled={!mmmFile}
                            />
                          </div>
                        </div>
                        <div style={{ width: 700 }}>
                          <p>
                            there should be 5 sets of question answers and each
                            set should have 4 question answers. Also make sure
                            to include total score.
                          </p>
                          <p>
                            please make sure to add the csv header column like
                            the following Division , Team number , Set ,
                            Question 1 , Question 2 , Question 3 , Question 4 ,
                            Score
                          </p>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: 20,
                              justifyContent: "flex-end",
                            }}
                          >
                            <ReusableButton
                              text="Download MMM Csv"
                              fontSize={15}
                              bgColor={"var(--color-primary)"}
                              height={46}
                              marginRight={30}
                              onClick={downloadMMMTemplate}
                              iconType="download"
                            />
                          </div>
                        </div>
                      </Grid>
                    ),
                  },
                  {
                    label: "MW",
                    key: "MW",
                    children: (
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems={"start"}
                        style={{ padding: 32 }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 20,
                          }}
                        >
                          <NunitoText
                            value="Only Upload CSV or XLSX File"
                            fontSize={20}
                            fontWeight={600}
                            color="var(--color-primary)"
                            align="left"
                          />

                          <div>
                            <input
                              type="file"
                              accept=".csv, .xlsx"
                              onChange={handleMvFileChange}
                            />
                          </div>
                          <ReusableButton
                            text="Upload File"
                            bgColor="var(--color-primary)"
                            fontSize={14}
                            height={44}
                            width={140}
                            iconType="save"
                            onClick={() => handleMWFileUpload()}
                            disabled={!mvFile}
                          />
                          {/* <button
                      onClick={() =>
                        handleUploadFile(
                          "competition/team-based/2025-simoc/mw/upload-answers",
                          file
                        )
                      }
                    >
                      Upload
                    </button> */}
                        </div>

                        <div style={{ width: 700 }}>
                          <p>
                            there should be only one answer for each question
                            and number of answers must no exceed the amount of
                            questions
                          </p>
                          <p>
                            please make sure to add the csv header column like
                            the following Index Number , Grade , Division , Team
                            Number , R1G1, ...
                          </p>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: 20,
                              justifyContent: "flex-end",
                            }}
                          >
                            <ReusableButton
                              text="Download MW Csv"
                              fontSize={15}
                              bgColor={"var(--color-primary)"}
                              height={46}
                              marginRight={30}
                              onClick={downloadMWTemplate}
                              iconType="download"
                            />
                          </div>
                        </div>
                      </Grid>
                    ),
                  },
                ]
              : [
                  {
                    label: "",
                    key: "",
                    children: (
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems={"center"}
                        style={{ padding: 32 }}
                      >
                        <div>
                          <NunitoText
                            value={`File Select:${
                              csvFile ? ` ${csvFile.name}` : ""
                            }`}
                            fontSize={20}
                            fontWeight={600}
                            color="var(--color-primary)"
                            align="left"
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 20,
                            }}
                          >
                            <NunitoText
                              value="Only Upload CSV or XLSX File"
                              fontSize={20}
                              fontWeight={600}
                              color="var(--color-primary)"
                              align="left"
                            />

                            <div>
                              <input
                                type="file"
                                accept=".csv, .xlsx"
                                onChange={handleNonSimocCompetitionFileChange}
                              />
                            </div>
                            <ReusableButton
                              text="Upload File"
                              bgColor="var(--color-primary)"
                              fontSize={14}
                              height={44}
                              width={140}
                              iconType="save"
                              onClick={() =>
                                handleNonSimocCompetitionFileUpload()
                              }
                              disabled={!nonSimocCompetitionFile}
                            />
                          </div>
                        </div>
                        <div style={{ width: 700 }}>
                          {/* TODO: Add the correct text for the general competition template. */}
                          <p>
                            there should be 5 sets of question answers and each
                            set should have 4 question answers. Also make sure
                            to include total score.
                          </p>
                          <p>
                            please make sure to add the csv header column like
                            the following Division , Team number , Question 1 ,
                            Question 2 , Question 3 , Question 4
                          </p>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: 20,
                              justifyContent: "flex-end",
                            }}
                          >
                            <ReusableButton
                              text="Download Csv"
                              fontSize={15}
                              bgColor={"var(--color-primary)"}
                              height={46}
                              marginRight={30}
                              onClick={downloadGeneralCompetitionTemplate}
                              iconType="download"
                            />
                          </div>
                        </div>
                      </Grid>
                    ),
                  },
                ]
          }
        />
      </Grid>
    </Box>
  );
}
